module.exports = __webpack_public_path__ + "static/media/11-video.7f279138.png";